import React, { useMemo } from "react";

function formatYMD(raw) {
  const val = String(raw ?? "")
    .replace(/\D/g, "")
    .slice(0, 8);
  const y = val.slice(0, 4);
  const m = val.slice(4, 6);
  const d = val.slice(6, 8);
  const parts = [];
  if (y) parts.push(y);
  if (m) parts.push(m);
  if (d) parts.push(d);
  return { raw: val, formatted: parts.join("/") };
}

const UserProfileDate = ({
  fieldLabel,
  placeholder,
  name,
  value,
  onChange,
  type = "text",
  disabled = false,
  dateMode = false,
  onBlur,
}) => {
  const displayValue = useMemo(() => {
    if (!dateMode) return value ?? "";
    return formatYMD(value).formatted;
  }, [dateMode, value]);

  const handleInput = (e) => {
    if (!dateMode) {
      onChange?.(e);
      return;
    }
    const rawDigits = String(e.target.value ?? "")
      .replace(/\D/g, "")
      .slice(0, 8);
    onChange?.({ target: { name, value: rawDigits } });
  };

  return (
    <div className="form-group col-xl-12">
      <label className="me-sm-2">{fieldLabel}</label>
      <input
        type={dateMode ? "text" : type}
        className="form-control"
        placeholder={dateMode ? placeholder || "YYYY/MM/DD" : placeholder}
        name={name}
        value={displayValue}
        onChange={handleInput}
        onBlur={onBlur}
        disabled={disabled}
        inputMode={dateMode ? "numeric" : undefined}
        pattern={undefined}
        maxLength={dateMode ? 10 : undefined}
        autoComplete={dateMode ? "bday" : undefined}
      />
    </div>
  );
};

export default UserProfileDate;
